<template>
  <div id="app">
    <!-- 赛博朋克背景元素 -->
    <div class="cyber-grid"></div>
    <div class="light-column"></div>
    <div class="light-column"></div>
    <div class="light-column"></div>
    <div class="light-column"></div>
    <div class="light-column"></div>
    
    <HomePage />
  </div>
</template>

<script>
import HomePage from './components/HomePage.vue'

export default {
  name: 'App',
  components: {
    HomePage
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);
  font-family: 'Rajdhani', 'Microsoft YaHei', sans-serif;
  min-height: 100vh;
  color: #fff;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  position: relative;
}

/* 赛博朋克背景元素 */
.cyber-grid {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    radial-gradient(circle at center, rgba(89, 10, 176, 0.2) 0%, transparent 80%),
    linear-gradient(to right, rgba(64, 224, 208, 0.1) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(64, 224, 208, 0.1) 1px, transparent 1px);
  background-size: 100% 100%, 50px 50px, 50px 50px;
  z-index: -1;
  opacity: 0.6;
}

/* 霓虹光柱效果 */
.light-column {
  position: fixed;
  top: -100px;
  width: 4px;
  height: 200px;
  background: linear-gradient(to top, rgba(0,247,255,0.8), transparent);
  box-shadow: 0 0 30px 5px rgba(0,247,255,0.8);
  animation: scan 8s infinite linear;
  z-index: -1;
}

.light-column:nth-child(2) {
  left: 10%;
  animation-delay: 0s;
}

.light-column:nth-child(3) {
  left: 30%;
  animation-delay: -2s;
}

.light-column:nth-child(4) {
  left: 50%;
  animation-delay: -4s;
}

.light-column:nth-child(5) {
  left: 70%;
  animation-delay: -6s;
}

.light-column:nth-child(6) {
  left: 90%;
  animation-delay: -1s;
}

@keyframes scan {
  0% { top: -100px; }
  50% { top: 100vh; }
  100% { top: 100vh; }
}
</style>
